import { DataRoleContentType } from '../../models/ContentTypes';

export let Capabilities = {
  // common
  read: 'read',
  write: 'write',
  deleteItem: 'delete', // This property name "delete" is not allowed in IE7.
  changePermissions: 'change_permissions',

  // view (and workbook and project)
  filter: 'filter',
  addComment: 'add_comment',
  viewComments: 'view_comments',
  exportData: 'export_data',
  vud: 'vud',
  exportImage: 'export_image',
  shareView: 'share_view',
  webAuthoring: 'web_authoring',

  // workbook and datasource and flow
  exportXml: 'export_xml',
  changeHierarchy: 'change_hierarchy',

  // datasource only
  connect: 'connect',

  // flow only
  execute: 'execute',

  // project only
  projectLeader: 'project_leader',
  inheritedProjectLeader: 'inherited_project_leader', // This is a read-only capability, not shown in the permissions data grid
};

const DataRoleCapabilities = [
  Capabilities.changeHierarchy,
  Capabilities.changePermissions,
  Capabilities.deleteItem,
  Capabilities.read,
  Capabilities.write
];

const DatasourceCapabilities = [
  Capabilities.changePermissions,
  Capabilities.connect,
  Capabilities.deleteItem,
  Capabilities.exportXml,
  Capabilities.read,
  Capabilities.write
];

const FlowCapabilities = [
  Capabilities.changeHierarchy,
  Capabilities.changePermissions,
  Capabilities.deleteItem,
  Capabilities.execute,
  Capabilities.exportXml,
  Capabilities.read,
  Capabilities.write
];

const CatalogCapabilities = [
  Capabilities.changePermissions,
  Capabilities.read,
  Capabilities.write
];

const ProjectCapabilities = [
  Capabilities.projectLeader,
  Capabilities.read,
  Capabilities.write
];

const ViewCapabilities = [
  Capabilities.addComment,
  Capabilities.changePermissions,
  Capabilities.deleteItem,
  Capabilities.exportData,
  Capabilities.exportImage,
  Capabilities.filter,
  Capabilities.read,
  Capabilities.shareView,
  Capabilities.viewComments,
  Capabilities.vud,
  Capabilities.webAuthoring
];

const WorkbookCapabilities = [
  Capabilities.addComment,
  Capabilities.changeHierarchy,
  Capabilities.changePermissions,
  Capabilities.deleteItem,
  Capabilities.exportData,
  Capabilities.exportImage,
  Capabilities.exportXml,
  Capabilities.filter,
  Capabilities.read,
  Capabilities.shareView,
  Capabilities.viewComments,
  Capabilities.vud,
  Capabilities.webAuthoring,
  Capabilities.write
];

export let CapabilitiesByContentType: _.Dictionary<string[]> = {
  dataRole: DataRoleCapabilities,
  datasource: DatasourceCapabilities,
  flow: FlowCapabilities,
  project: ProjectCapabilities,
  projectDataRoleTemplate: DataRoleCapabilities,
  projectDatasourceTemplate: DatasourceCapabilities,
  projectFlowTemplate: FlowCapabilities,
  projectWorkbookTemplate: WorkbookCapabilities,
  view: ViewCapabilities,
  workbook: WorkbookCapabilities,
  table: CatalogCapabilities,
  databaseTableTemplate: CatalogCapabilities,
  database: CatalogCapabilities,
};
